import { AuthIntegration, StoredCredential } from "@istari/istari-client";

import { toControlTagSummaries } from "~/control-tags/data-source/adapter/to-control-tag-summary";

import { ConnectableIntegration, Connection } from "../../model/connection";

function humanizeType(type: string): string {
  return type
    .split("_")
    .map((word) => (word ? word[0].toUpperCase() + word.slice(1).toLowerCase() : word))
    .join(" ");
}

export function toConnection(credential: StoredCredential): Connection {
  return {
    id: credential.id,
    name: credential.name,
    accountIdentity: credential.accountIdentity ?? null,
    authType: credential.authType,
    status: credential.status,
    authIntegrationId: credential.authIntegrationId ?? null,
    ownerUserId: credential.ownerUserId ?? null,
    controlTags: toControlTagSummaries(credential.controlTags),
  };
}

export function toConnectableIntegration(integration: AuthIntegration): ConnectableIntegration {
  return {
    id: integration.id,
    type: integration.authIntegrationType,
    name: integration.name ?? humanizeType(integration.authIntegrationType),
    authType: integration.authType,
  };
}
